import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { selectSubMode } from '../../features/master/masterSlice';
import { isNoneSubMode, isSubConsultMode, isSubCreateMode, isSubUpdateMode } from "../../utils/store/store-utils";
import QCXFinalFormWizard from "../../shared-components/final-form-wizard/QCXFinalFormWizard";
import QCXMasterForm from "./QCXMasterForm";
import QCXMasterCustoForm from "./QCXMasterCustoForm";

export default function QCXMasterWizardFinalForm({
  isIdle, 
  isLoading,
  isFailure,
  isCreate,
  isConsult,
  isUpdate,
  isLocked,
  isBackgroundCreate,
  isBackgroundDelete,
  isSubBackgroundCreate,
  isSubBackgroundConsult,
  isSubBackgroundUpdate,
  isSubBackgroundDelete,
  isPreparingAction,
  handleSubmit,
  handleCustomSaveBy,
  handleAlternativeSave,
  model,
  handleChangeModel,
  handleChangeToCreate,
  handleChangeToConsult,
  handleChangeToUpdate,
  handleCancelUpdate,
  handleChangeToBackgroundCreate,
  handleChangeToBackgroundDelete,
  handleResetBackgroundMode,
  tipoFrete,
  setTipoFrete,
  tipoEmbarque,
  setTipoEmbarque,
  tipoPagamento,
  setTipoPagamento,
  declarado,
  setDeclarado,
  setMasterCustos,
  authInfo = {},
  requiredRoles = [],
  ...restProps
}) {

    const { t } = useTranslation();

    const wizardSteps = useMemo(() => {
        const stepsLabels = [
            t('com.muralis.qcx.master.wizardSteps.cabecalho'),
            t('com.muralis.qcx.master.wizardSteps.custo'),
          ];
        return stepsLabels;
    },[]);

    const subMode = useSelector(selectSubMode);

    const isSubNone = useMemo(() => isNoneSubMode(subMode), [subMode]);

    const isSubCreate = useMemo(() => isSubCreateMode(subMode), [subMode]);
  
    const isSubConsult = useMemo(() => isSubConsultMode(subMode), [subMode]);
  
    const isSubUpdate = useMemo(() => isSubUpdateMode(subMode), [subMode]);
  
    const checkIfIsAlternativeSaveByStep = (currentStep) => currentStep === 1;

    return (
        <QCXFinalFormWizard
            steps={wizardSteps}
            initialValues={model}
            handleChangeValues={handleChangeModel}
            isConsult={isConsult}
            persistValuesOnStepChange
            isUpdate={isUpdate}
            isBackgroundCreate={isBackgroundCreate}
            isSubNone={isSubNone}
            isSubCreate={isSubCreate}
            isSubConsult={isSubConsult}
            isSubUpdate={isSubUpdate}
            handleSubmit={handleSubmit}
            checkIfIsAlternativeSaveByStep={checkIfIsAlternativeSaveByStep}
            handleAlternativeSave={handleAlternativeSave}
            handleChangeToCreate={handleChangeToCreate}
            handleChangeToConsult={handleChangeToConsult}
            handleChangeToUpdate={handleChangeToUpdate}
            handleCancelUpdate={handleCancelUpdate}
            handleChangeToBackgroundCreate={handleChangeToBackgroundCreate}
            handleResetBackgroundMode={handleResetBackgroundMode}
            {...restProps}
        >
              {(formProps) => (
                      <QCXMasterForm
                        key="cabecalho"
                        isConsult={isConsult}
                        isUpdate={isUpdate}
                        authInfo={authInfo}
                        requiredRoles={requiredRoles}
                        tipoEmbarque={tipoEmbarque}
                        setTipoEmbarque={setTipoEmbarque}
                        tipoFrete={tipoFrete}
                        setTipoFrete={setTipoFrete}
                        {...formProps}
                      />
                    )}
            {(formProps) => (
                <QCXMasterCustoForm
                    key="custos"
                    isConsult={isConsult}
                    isUpdate={isUpdate}
                    authInfo={authInfo}
                    requiredRoles={requiredRoles}
                    tipoEmbarque={tipoEmbarque}
                    setTipoEmbarque={setTipoEmbarque}
                    tipoPagamento={tipoPagamento}
                    setTipoPagamento={setTipoPagamento}
                    declarado={declarado}
                    setDeclarado={setDeclarado}
                    setMasterCustos={setMasterCustos}
                    {...formProps}
                />
            )}
            
        </QCXFinalFormWizard>
    )
}